// forced to use swiper 4 instead 9, due to an issue with old css and fade effect animation
import { LazySwiperWhenVisible } from '@/utils/Controllers/LazySwiperController';
import SmarteditController from '@/utils/Controllers/SmarteditController';
import _isEmpty from 'lodash/isEmpty';

const SELECTOR = '.js-del-featureslist';

const loadController = async (slider, SwiperLib) => {
  const controller = await import(
    /* webpackChunkName: "DELFeaturesListController-lib" */ '@/delonghi/Controllers/DELFeaturesList/DELFeaturesListController'
  );
  controller.default(slider, SwiperLib);
};

const init = () => {
  const entries = SmarteditController.getEditorialEntries(SELECTOR);
  if (!_isEmpty(entries)) {
    LazySwiperWhenVisible(entries, async (slider, SwiperLib) => {
      loadController(slider, SwiperLib);
    });
  }
};

export default async () => {
  SmarteditController.addOnReprocessPageListener(init);
  init();
};
